import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class SpecialProgrammesRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return indexableFilters.length === 1 && indexableFilters.some((_) => _.type === ParameterType.SPECIAL_PROGRAMMES);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.SPECIAL_PROGRAMMES_ROUTE,
			params: {
				special_programmes: this.extractPath(filters.find((_) => _.type === ParameterType.SPECIAL_PROGRAMMES))
			}
		};
	}
}
